module.exports = __webpack_public_path__ + "media/images/icon-close-ticket-alternate-54fbb77835d1c41911f9b6d1e3fc07c0.svg";